export default {
	"superAddressComp": {
		"pickUpPoint": "จุดรับส่ง"
	},
	"tempSpanComp": {
		"noLimit": "ไม่จำกัด"
	},
	"searchComp": {
		"orderNo": "หมายเลขคำสั่งขนส่ง",
		"transportNo": "หมายเลขใบตราส่งสินค้า",
		"taskNo": "หมายเลขงาน",
		"originNo": "หมายเลขคำสั่งภายนอก",
		"transferNo": "หมายเลขคำสั่งส่งมอบ",
		"routeNo": "หมายเลขคำสั่งจัดส่ง"
	}
}


// WEBPACK FOOTER //
// ./src/lang/th/components/searchComponent/searchComponent.js